import bridgeImage from "./bridge2.jpg";
import { InstallBlock } from "./components/InstallBlock.tsx";
import "./index.css";

export function App() {
  return (
    <main className="min-h-screen w-full flex flex-col lg:flex-row bg-[#f4f4f4] text-black">
      {/* Left Content Column */}
      <div className="flex-1 flex flex-col justify-center px-8 lg:px-24 xl:px-32 relative z-10 pt-20 lg:pt-0">
        <div className="max-w-2xl">
          <h1 className="text-5xl lg:text-7xl font-bold tracking-tight mb-6">
            CodeBridge
          </h1>
          <p className="text-lg lg:text-xl text-neutral-600 mb-10 leading-relaxed font-sans max-w-xl">
            The multi-agent CLI that orchestrates coding tools seamlessly. Plan smarter, execute faster, preserve context.
          </p>

          <InstallBlock />
        </div>
      </div>

      {/* Right Image Column */}
      <div className="flex-1 relative min-h-[50vh] lg:min-h-screen w-full flex items-center justify-center overflow-hidden">
        {/* We use an absolute positioned image to act as a background cover for the right half */}
        <div className="absolute inset-0 w-full h-full bg-black/5 z-0" />
        <img
          src={bridgeImage}
          alt="Dithered Bridge"
          className="absolute inset-0 w-full h-full object-cover object-center mix-blend-multiply opacity-90"
          style={{
            imageRendering: 'pixelated'
          }}
        />
      </div>
    </main>
  );
}

export default App;
